{
  "version": 1,
  "asset_id": "2ae807fb-0727-41d3-98be-93a084e15390",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2ae807fb-0727-41d3-98be-93a084e15390/dilated-pouch-contrast-980.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2ae807fb-0727-41d3-98be-93a084e15390/dilated-pouch-contrast-980.webp",
  "original_filename": "dilated-pouch-contrast-980.webp",
  "size": 40390,
  "content_type": "image/webp",
  "created_at": "2026-09-20T23:09:11Z"
}
